import Subscription from "./Subscription";
import RegisterStep1 from "./RegisterStep1";
import RegisterStep2 from "./RegisterStep2";
import ProfileSetupStep1 from "./ProfileSetupStep1";
import ProfileSetupStep2 from "./ProfileSetupStep2";
import ProfileSetupStep3 from "./ProfileSetupStep3";
import ProfileSetupStep4 from "./ProfileSetupStep4";
import FreeTrialModal from "./FreeTrialModal";

const HandleRenderDiv = ({ registerStep, stepBack, backToLogin, onClose, isSubscription, setIsSubscription }) => {

  switch (registerStep) {
    case "subscription":
      return <Subscription
        setIsSubscription={setIsSubscription}
        isSubscription={isSubscription}
      />;
    case "freeTrial":
      return <FreeTrialModal />;
    case 1:
      return (
        <>
          <RegisterStep1 stepBack={stepBack} backToLogin={backToLogin} />
        </>
      );
    case 2:
      return (
        <>
          <RegisterStep2 backToLogin={backToLogin} onClose={onClose} />
        </>
      );
    case "profileStep1":
      return (
        <>
          <ProfileSetupStep1 />
        </>
      );
    case "profileStep2":
      return (
        <>
          <ProfileSetupStep2 />
        </>
      );
    case "profileStep3":
      return (
        <>
          <ProfileSetupStep3 />
        </>
      );
    case "profileStep4":
      return (
        <>
          <ProfileSetupStep4 backToLogin={backToLogin} />
        </>
      );
  }
};

export default HandleRenderDiv;
